import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const counterSlice = createSlice({
  name: 'counter',
  initialState: {
    value: 0,
    datos:null
  },
  reducers: {
    increment: state => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: state => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },

    setDatos: (state, action) => {
      console.log(" states setDatos");
        state.datos = action.payload;
      },

  },
});

export const { increment, decrement, incrementByAmount, setDatos } = counterSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const incrementAsync = amount => dispatch => {
  setTimeout(() => {
    dispatch(incrementByAmount(amount));
  }, 1000);
};



export const loadData =  amount => async dispatch => {

     axios.get(  process.env.REACT_APP_API_ENDPOINT + 'app' ).then(
         (result)=>{
            console.log( "result axios counter", result);
            dispatch(setDatos(result.data));
         }
     );
    
  };



// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectCount = state => state.counter.value;
export const selectDatos = state => state.counter.datos;

export default counterSlice.reducer;
